import { UNDO_LIMIT, useSceneStore } from "../store/sceneStore";
import type { SceneObjectData } from "../types";

interface Baseline {
  objects: SceneObjectData[];
  selectedId: string | null;
}

let baseline: Baseline | null = null;

/** Suspends undo tracking and remembers the state as it was *before* editing
 *  started, so a burst of intermediate values (dragging a slider, scrubbing
 *  the gizmo, typing) collapses into a single undo step instead of one per
 *  tick. Nested/repeated calls keep the original (earliest) baseline. */
export function pauseUndo() {
  const temporal = useSceneStore.temporal.getState();
  if (!temporal.isTracking) return;
  const state = useSceneStore.getState();
  baseline = { objects: state.objects, selectedId: state.selectedId };
  temporal.pause();
}

/** Resumes tracking and pushes the pre-edit baseline as a single undo step
 *  reflecting whatever changed while paused. Safe to call even if nothing
 *  was paused (no-op). */
export function commitUndo() {
  const temporal = useSceneStore.temporal.getState();
  if (temporal.isTracking) return;
  temporal.resume();
  if (baseline) {
    const pastStates = [...useSceneStore.temporal.getState().pastStates, baseline];
    while (pastStates.length > UNDO_LIMIT) pastStates.shift();
    useSceneStore.temporal.setState({ pastStates, futureStates: [] });
    baseline = null;
  }
}
